import { useState, useLayoutEffect } from "react";
import { Breakpoint } from "types/breakpoint";

function useBreakPoint(breakPoint: Breakpoint) {
    const [match, setMatch] = useState(() => {
        return window.matchMedia(`(${breakPoint})`).matches;
    });
    useLayoutEffect(() => {
        let active = true;
        function checkWindowWidth(e: MediaQueryList | MediaQueryListEvent) {
            if (active) {
                setMatch(e.matches);
            }
        }
        const match = window.matchMedia(`(${breakPoint})`);
        checkWindowWidth(match);
        match.addListener(checkWindowWidth);
        return () => {
            active = false;
            match.removeListener(checkWindowWidth);
        };
    }, []);
    return match;
}

export default useBreakPoint;
